import React from "react";
import Container from "./Container.jsx";

export default function ContactBand() {
  return (
    <section id="contact" className="py-12 bg-slate-50">
      <Container className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h3 className="text-xl font-bold text-[#003366]">Ready to discuss a brief?</h3>
          <p className="text-[#003366]">Tell us your goals and timeline - we’ll respond the same business day.</p>
        </div>
        <a href="info@ethirapropertygroup.co.uk" className="w-full sm:w-auto rounded-xl px-5 py-3 text-white font-semibold bg-[#003366] hover:bg-slate-800 text-center">
          info@ethirapropertygroup.co.uk
        </a>
      </Container>
    </section>
  );
}
